
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Onlinecabbookingpune() {



    const cardData =
    {
        keyword: 'Online Cab Booking Pune',
        heading: 'Meghana Cab : Online Cab Booking Pune ',
        headingDescription: 'Meghana Cab offers online cab booking in Pune, enabling you to reserve your ride seamlessly from the comfort of your home or office. Whether you need a city cab for local errands, airport transfers, or long-distance travel, our easy-to-use online platform ensures fast confirmation, transparent fare estimates, and flexible scheduling. Choose from a variety of well-maintained AC sedans, SUVs, and tempo travellers, and enjoy 24/7 customer support, verified drivers, prompt pickups, and a reliable travel experience. Book your cab online in Pune with Meghana Cab and travel with ease, safety, and confidence.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada Fort",
    "description": "Shaniwar Wada stands as Pune’s most iconic landmark — a majestic fort that was once the royal seat of the Peshwas of the Maratha Empire. Built in 1732, its massive stone walls, intricate wooden gates, and sprawling courtyards narrate tales of valor, politics, and romance. The grand Delhi Gate welcomes visitors into a world of Maratha glory, where ruins still whisper stories of Bajirao I and Mastani. At night, a spectacular light and sound show brings the fort’s history alive under the stars. The lush gardens and historic aura make Shaniwar Wada a timeless reminder of Pune’s royal heritage and architectural splendor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not only an architectural gem but also a site of deep historical importance. Built in 1892 by Sultan Aga Khan III, this grand palace played a key role in India’s freedom struggle. It served as the prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace functions as a memorial and museum, showcasing photographs, personal items, and freedom movement memorabilia. Its Italian-style arches, manicured lawns, and serene surroundings make it both a place of learning and reflection — a tribute to peace, resilience, and India’s path to independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri ranges about 35 km from Pune, Sinhagad Fort offers breathtaking views and a thrilling sense of history. The fort, meaning ‘Lion’s Fort,’ was the site of the famous Battle of Sinhagad where the brave Maratha warrior Tanaji Malusare fought valiantly for Shivaji Maharaj. Trekking up the hill reveals ancient ramparts, gates, and bastions wrapped in mist and greenery. The local stalls serving piping-hot kanda bhaji and curd add rustic charm to the adventure. With its panoramic views, monsoon clouds, and heroic tales, Sinhagad is the perfect blend of nature, history, and Marathi pride."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered and visually stunning temples. Established over a century ago, it houses a magnificent idol of Lord Ganesha adorned with gold and precious ornaments. The temple attracts millions of devotees, especially during the grand Ganesh Chaturthi celebrations when the streets of Pune come alive with lights, music, and devotion. The temple’s intricate design, serene ambiance, and community-driven charity work make it a spiritual cornerstone of the city. Visiting Dagdusheth is not only a religious experience but also a glimpse into Pune’s deep-rooted cultural and devotional traditions."
  },
  {
    "title": "Parvati Hill and Temple Complex",
    "description": "Parvati Hill, standing gracefully at the city’s heart, offers panoramic views of Pune and a serene spiritual retreat. The hill is home to the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, along with several smaller shrines and a Peshwa museum. Climbing its 108 stone steps feels both meditative and rewarding as the city unfolds below. The temple’s calm ambiance, ancient sculptures, and scenic sunrise or sunset views make it a favorite for photographers and peace seekers. It remains a perfect blend of devotion, history, and natural beauty — an essential stop on any Pune itinerary."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum offers a fascinating glimpse into India’s diverse art and cultural heritage. Curated by Dr. Dinkar Kelkar in memory of his son, this three-storey museum houses over 20,000 artifacts — including antique musical instruments, rare sculptures, Mughal-era weaponry, and traditional Indian ornaments. The highlight is the reconstructed Mastani Mahal, showcasing royal décor and intricate woodwork from the Peshwa era. Every corridor tells a story of craftsmanship and creativity. For history enthusiasts and art lovers, the museum serves as a treasure trove that captures India’s timeless aesthetic and Pune’s cultural spirit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved from a single basalt rock in the 8th century, the Pataleshwar Cave Temple is one of Pune’s oldest architectural wonders. Dedicated to Lord Shiva, the temple features a massive Nandi bull, intricately sculpted pillars, and a circular stone courtyard that exudes divine tranquility. Despite being located along a busy road, the temple offers a peaceful oasis in the city. Its unique monolithic structure and ancient carvings transport visitors back to the times of the Rashtrakuta dynasty. For those interested in spirituality and history, Pataleshwar is a hidden gem reflecting Pune’s ancient roots and artistic mastery."
  },
  {
    "title": "Osho Ashram (OSHO International Meditation Resort)",
    "description": "Located in the leafy Koregaon Park area, the Osho Ashram is one of the world’s most renowned spiritual centers. Founded by spiritual teacher Osho Rajneesh, it offers meditation programs, wellness therapies, and peaceful gardens designed to promote inner balance. The ashram’s serene pathways, zen-like architecture, and marble meditation halls create an atmosphere of deep calm. Visitors from around the world come here to rejuvenate through yoga, silence, and mindfulness. Surrounded by upscale cafes and art boutiques, the Osho Ashram reflects Pune’s global, cosmopolitan soul while offering a sanctuary for peace and spiritual awakening."
  },
  {
    "title": "Khadakwasla Dam and Panshet Lake",
    "description": "Khadakwasla Dam, located on the Mutha River, is one of Pune’s most scenic picnic spots. The wide expanse of calm blue water against the backdrop of green hills creates a postcard-perfect landscape. It is also the source of the city’s water supply and lies close to the Indian National Defence Academy (NDA). A short drive further leads to Panshet and Varasgaon dams — ideal for boating, photography, and weekend getaways. The gentle breeze, monsoon mist, and local food stalls make the area a relaxing retreat. It’s where nature, adventure, and tranquility meet just outside the city limits."
  },
  {
    "title": "Vetal Tekdi and Pashan Lake",
    "description": "Vetal Tekdi, the highest point in Pune, offers panoramic views of the city and surrounding hills. Covered in dense vegetation, it’s a favorite spot for morning joggers, trekkers, and nature enthusiasts. The nearby Pashan Lake is a beautiful birdwatching site, home to migratory species like herons and kingfishers. Together, these natural escapes showcase Pune’s green soul amid its urban expansion. The peaceful sunrise views, cool breeze, and chirping birds provide a perfect start to the day. For travelers seeking calm, fitness, or photography, Vetal Tekdi and Pashan Lake deliver an unforgettable nature experience within city limits."
  }
],


        "services": [
    {
      "name": "Online Cab Booking Pune",
      "description": "Book your cab online in Pune easily with Meghana Cab. Whether you need local rides or outstation trips, our online platform offers instant booking, real-time tracking, and affordable fares. Choose from a range of vehicles including Innova, Ertiga, and Sedans for a safe and comfortable journey."
    },
    {
      "name": "Online Auto Booking in Pune",
      "description": "Conveniently book auto rickshaws online in Pune with Meghana Cab. Get quick rides within the city with hassle-free payments and reliable service. Perfect for short-distance travel and quick errands."
    },
    {
      "name": "Taxi Booking Pune",
      "description": "Easily book a taxi in Pune with Meghana Cab’s online service. Enjoy clean vehicles, professional drivers, and transparent pricing for both local and outstation travel. Our user-friendly platform ensures a smooth booking experience."
    },
    {
      "name": "Online Taxi Booking Pune",
      "description": "Experience seamless online taxi booking in Pune with Meghana Cab. Get instant confirmation, safe rides, and well-maintained cars for your travel needs, including airport transfers and city tours."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      "description": "Book your taxi online from Mumbai Airport to Pune with Meghana Cab. Enjoy timely pickups, comfortable rides, and competitive fares with professional drivers ensuring a smooth journey after your flight."
    },
    {
      "name": "Pune to Shirdi Cab Booking Online",
      "description": "Plan your pilgrimage trip with easy online cab booking from Pune to Shirdi. Choose from Innova, Ertiga, and Sedans with professional drivers for a comfortable and safe journey to the holy city."
    },
    {
      "name": "Online Car Booking in Pune",
      "description": "Book a car online in Pune hassle-free with Meghana Cab. Whether for local travel or outstation trips, select from a range of vehicles including Innova Crysta, Ertiga, and Sedans with flexible booking options."
    },
    {
      "name": "Online Cab Services in Pimpri Chinchwad",
      "description": "Access reliable online cab services in Pimpri Chinchwad with Meghana Cab. Book your ride instantly for local travel or airport transfers with trusted drivers and well-maintained vehicles."
    },
    {
      "name": "Online Cab Services in Pimpri Chinchwad Contact Number",
      "description": "Contact Meghana Cab for online cab services in Pimpri Chinchwad. Call us to book your ride quickly or get assistance with your online booking for convenient, safe, and affordable travel."
    },
    {
      "name": "Online Cab Service Innova Crysta",
      "description": "Book Innova Crysta online with Meghana Cab for luxurious and spacious travel in Pune. Ideal for family trips, corporate travel, and outstation journeys with professional chauffeurs."
    },
    {
      "name": "Online Cab Services in Innova Cabs",
      "description": "Choose from our fleet of Innova cabs with easy online booking. Meghana Cab offers premium Innova services for comfortable and reliable travel across Pune and beyond."
    },
    {
      "name": "Online Cab Service in Pune",
      "description": "Experience the best online cab service in Pune with Meghana Cab. Book your ride anytime, anywhere, with instant confirmation, transparent fares, and a wide choice of vehicles."
    },
    {
      "name": "Ertiga Outstation Booking Pune",
      "description": "Book Ertiga cabs online for outstation trips from Pune with Meghana Cab. Enjoy spacious seating, AC comfort, and professional drivers for your long-distance travel needs."
    }
  ],
  "tableData": [
    ["Online Cab Booking Pune", "Online Auto Booking in Pune"],
    ["Taxi Booking Pune", "Online Taxi Booking Pune"],
    ["Mumbai Airport to Pune Taxi Online Booking", "Pune to Shirdi Cab Booking Online"],
    ["Online Car Booking in Pune", "Online Cab Services in Pimpri Chinchwad"],
    ["Online Cab Services in Pimpri Chinchwad Contact Number", "Online Cab Service Innova Crysta"],
    ["Online Cab Services in Innova Cabs", "Online Cab Service in Pune"],
    ["Ertiga Outstation Booking Pune", ""]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Hassle-Free Online Cab Booking in Pune",
        "WhyChoosedescription": "Meghana Cab offers a simple and convenient online cab booking platform in Pune, allowing you to schedule your ride in just a few clicks."
    },
    {
        "WhyChooseheading": "Instant Booking Confirmation",
        "WhyChoosedescription": "Get real-time booking confirmation and driver details right after your online booking. No waiting, no uncertainty—just instant service."
    },
    {
        "WhyChooseheading": "Multiple Cab Options Available",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers based on your travel needs—perfect for solo rides, family trips, or business travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "With clear pricing and no hidden charges, Meghana Cab ensures your online booking is not only fast but also budget-friendly."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "All cabs booked online are regularly sanitized and well-maintained, with essential safety features like GPS tracking and seat belts."
    },
    {
        "WhyChooseheading": "24/7 Online Booking Availability",
        "WhyChoosedescription": "Book your ride anytime, anywhere. Meghana Cab's online booking system is live 24/7 to accommodate your early morning or late-night travel plans."
    },
    {
        "WhyChooseheading": "User-Friendly Website and App",
        "WhyChoosedescription": "Our intuitive website and mobile app make it easy to book cabs, track rides, and manage your trips with just a few taps."
    },
    {
        "WhyChooseheading": "Dedicated Support for Online Bookings",
        "WhyChoosedescription": "Need help while booking online? Our support team is always available to guide you through the process or assist with changes and queries."
    }
]






























    }










const faqData = [
    {
        question: "How can I book a cab online in Pune with Meghana Cab?",
        answer: "You can easily book a cab online through Meghana Cab’s official website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What types of cabs are available for online booking in Pune?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers, all available for online booking based on your needs."
    },
    {
        question: "Is online cab booking available for both local and outstation rides in Pune?",
        answer: "Yes, Meghana Cab supports online booking for both local city rides and outstation trips from Pune."
    },
    {
        question: "Can I schedule my cab in advance when booking online?",
        answer: "Yes, you can pre-book your cab online for a specific date and time to ensure availability."
    },
    {
        question: "Are there any special discounts or offers for online cab bookings?",
        answer: "Occasionally, Meghana Cab offers discounts and promotions on online bookings. Check our website or contact support for current offers."
    },
    {
        question: "What payment options are available for online cab bookings in Pune?",
        answer: "We accept online payments via UPI, credit/debit cards, net banking, and cash payments upon ride completion."
    },
    {
        question: "Is the online booking process secure?",
        answer: "Yes, Meghana Cab uses secure payment gateways and encryption to protect your personal and payment information."
    },
    {
        question: "Can I modify or cancel my online cab booking?",
        answer: "Yes, you can modify or cancel your booking by contacting our customer support at +91 9075462128."
    },
    {
        question: "How do I track my cab after booking online?",
        answer: "Once your booking is confirmed, you will receive details including driver info and real-time cab tracking via SMS or email."
    },
    {
        question: "How do I get support for online cab booking issues?",
        answer: "You can reach out to Meghana Cab’s customer service at +91 9075462128 for any assistance with online bookings."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Abhishek Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking a cab online with Meghana Cab was quick and hassle-free. The driver arrived on time, and the ride was very comfortable.”'
    },
    {
        name: 'Ms. Riya Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I loved the convenience of online booking with Meghana Cab. Great service and transparent pricing.”'
    }
];
















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Online Cab Booking Pune",
  "description": "Book your cab online in Pune with Meghana Cabs. Convenient and reliable taxi and auto booking services for local and outstation trips. Easy booking for Innova, Crysta, Ertiga, and more with just a few clicks.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3800"
  }
};





    return (
        <div>




<Helmet>
  <title>Online Cab Booking Pune | Easy & Reliable Taxi Booking @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book online cab in Pune with Meghana Cabs. Reliable taxi and auto booking services including Innova, Crysta, and Ertiga cabs. Convenient and hassle-free cab booking for local and outstation travel."
  />
  <meta
    name="keywords"
    content="Online Cab Booking Pune, online cab booking pune, online auto booking in pune, taxi booking pune, online taxi booking pune, mumbai airport to pune taxi online booking, pune to shirdi cab booking online, online car booking in pune, Online taxi pune, online cab services in pimpri chinchwad, Online cab services in pimpri chinchwad contact number, online cab service innova crysta, online cab services in innova cabs, online cab service in pune, ertiga outstation booking pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onlinecabbookingpune;